import React, { useContext, useEffect,useState } from "react";
import { TextField, Checkbox } from "@fluentui/react";
import "../Styles/EditPatientCss.css";
import "../../../../index.css";
import { CopyIcon } from "@fluentui/react-icons-mdl2";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";

const SendReportBody = (props) => {
  const { themeName,getAlterClass } = useContext(themeContext);
  const [emailFieldEnable, setEmailFieldEnable] = useState(false);
  const showOnlyEmailField = props.showOnlyEmailField;

  const handleCopyUrl = () => {
    let hiddenMessage = document.getElementById("copied-msg");
    let copyText = document.getElementById("report_url");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    hiddenMessage.style.display = "block";
    setTimeout(()=>{
      hiddenMessage.style.display = "none";
    },5000);
  };

  const checkBoxStyle = {
    text: {
      // color: "white",
      fontWeight: "bold",
    },
    checkbox: {
      // borderColor: "#ffffffa6",
    },
  };

  const emailCheckBoxStyle = {
    
    root:{
      margin:'0px',
      label:{
        display:'flex',
        alignItems:"center",
        marginRight:'10px'
      },
    },
    text: {
      // color: "white",
      fontWeight: "bold",
    },
    checkbox: {
      // borderColor: "#ffffffa6",
    },
  };

  // border: 1px solid rgba(200, 198, 196, 0.3);
  //   background: none transparent;

  const textFieldStyle = {
    fieldGroup: {
      '&.is-disabled': {
        background: 'gray !important',
        border:'1px solid rgba(200, 198, 196, 0.3) !important',
        cursor:'not-allowed',
      },
    },
    root:{
      borderRadius: '7px',
      '&.is-disabled': {
        backgroundColor: 'transparent !important',
        cursor:'not-allowed',
        border:'none !important'
      },
    },
    field: {
          backgroundColor: 'transparent !important',
          border:'1px solid rgba(200, 198, 196, 0.3) !important'
    },
  }
  

  const handleCopy = (e) => {
    e.preventDefault(); // Prevent Ctrl+C
  };

  useEffect(()=>{
    if(props.reportLinkChecked){
      console.log("--- True ----");
      setEmailFieldEnable(true);
    }else{
      console.log("--- False ----");
      setEmailFieldEnable(false);
    }
  },[props.reportLinkChecked])


  return (
    showOnlyEmailField ?<>
        <div style={{ padding: "30px 25px 30px 28px" }}>
        <div
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div className="study-list-send-report-label-container">
              <label className="study-list-send-report-label-text" htmlFor="">Email </label>
            </div>
            <TextField
              className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
              name="attachmentEmail "
              styles={textFieldStyle}
              value={props.attachmentEmail}
              onChange={(e) => props.setAttachmentEmail(e.target.value)}
              errorMessage={props.errors.attachmentEmail}
            />
          </div>

        </div>
    </> :
    <> 
      <div style={{ padding: "20px 25px 20px 16px" }}>
        {/* top,  shareReportLink div */}
        <div className="">
          <Checkbox
            shape="circular"
            styles={checkBoxStyle}
            label={t("label.share-link")}
            onChange={(e,data) => {
              console.log("--- Flag ---",data);
              if(!data){
                // props.setReportLink("");
                let hiddenMessage = document.getElementById("copied-msg");
                hiddenMessage.style.display = "none";
                props.setReportLinkEmail("");
              }
              props.setReportLinkChecked(!props.reportLinkChecked);
            }}
          />
          <div>
            <div
              className="ms-Grid-row"
              style={{
                display: "flex",
                flexDirection: "row",
                marginLeft: "50px",
              }}
            >
              <div className="study-list-send-report-label-container">
                <label className="study-list-send-report-label-text" htmlFor="">{t("label.url").toUpperCase()} </label>
              </div>

              <TextField
                className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                name="reportUrl"
                styles={textFieldStyle}
                id="report_url"
                onCopy={handleCopy}
                value={props.reportLink}
                disabled={!props.reportLinkChecked}
              />
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',marginLeft:'5px'}}>
              <CopyIcon
                id="copied_msg"
                onClick={()=>{if(props.reportLinkChecked){handleCopyUrl()}}}
                style={{ cursor: !props.reportLinkChecked?'not-allowed':'pointer',color:!props.reportLinkChecked?'gray':themeName === "light"?"black":"white", marginLeft: "5px",fontSize:'20px' }}
                disabled={!props.reportLinkChecked}
              />
              </div>
              
            </div>
            <p className={getAlterClass(themeName,"study-list-copied-msg")} id="copied-msg">
              {t("share-study.link-copied-successfully")}
            </p>
            <div
              className="ms-Grid-row"
              style={{
                display: "flex",
                flexDirection: "row",
                marginLeft: "11px",
                marginTop: "20px",
              }}
            >
              <Checkbox 
              onChange={(e,data) => {
                console.log("--- Flag ---",data);
                if(!data){
                  props.setReportLinkEmail("");
                }
                setEmailFieldEnable(data)
              }}
              styles={emailCheckBoxStyle} 
              checked={emailFieldEnable}
              shape="circular" 
              label={t("user.email")} />
              <TextField
                className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
                styles={textFieldStyle}
                name="reportEmail"
                value={props.reportLinkEmail}
                disabled={!props.reportLinkChecked || !emailFieldEnable}
                onChange={(e) => {
                  props.setReportLinkEmail(e.target.value);
                }}
                errorMessage={emailFieldEnable?props.errors.reportEmail:false}
              />
            </div>
          </div>
        </div>

        {/* buttom send Attachment div */}
        <div className="" style={{ marginTop: "15px" }}>
          <Checkbox
            styles={checkBoxStyle}
            shape="circular"
            label={t("label.send-attachment")}
            onChange={(e,data) => {
              props.setAttachmentChecked(data);
            }}
          />
          <div
            className="ms-Grid-row"
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "50px",
            }}
          >
            <div className="study-list-send-report-label-container">
              <label className="study-list-send-report-label-text" htmlFor="">{t("user.email")} </label>
            </div>
            <TextField
              className="form-field ms-sm12 ms-md8 ms-lg4 ms-xl12 border-adding"
              name="attachmentEmail "
              styles={textFieldStyle}
              value={props.attachmentEmail}
              disabled={!props.attachmentChecked}
              onChange={(e) => props.setAttachmentEmail(e.target.value)}
              errorMessage={props.errors.attachmentEmail}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SendReportBody;
